<template>
    <ListingTableFilter
        :filter="filter"
        :valuesHumanized="appliedFilterLabels"
        :filterConfig="filterConfig"
        @updateFilter="updateFilter"
        @updateVisibility="updateVisibility"
        @removeFilter="removeFilter"
    >
        <template #filterDropdownContent>
            <CompassDropdownOption
                v-for="option in filter.options"
                :key="option.id"
                v-bind="option"
                :value="option.id"
            />
        </template>
    </ListingTableFilter>
</template>
<script>
import ListingTableFilter from 'vcomponents/common/listing/filters/ListingTableFilter.vue';

export default {
    components: { ListingTableFilter },
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },
    computed: {
        appliedFilterLabels() {
            return this.filter.optionsSelected
                .map(
                    (valueId) => this.filter.options.find((option) => option.id === valueId)?.label,
                )
                .join(', ');
        },
        filterConfig() {
            return {
                isVisible: this.filter.displayDropdown,
                filterable: this.filter.filterable,
                multiple: this.filter.multiple,
                appliedButton: this.filter.applyLabel,
            };
        },
    },
    methods: {
        updateFilter(values) {
            this.$emit('updateFilter', values);
            this.updateVisibility(false);
        },
        removeFilter() {
            this.$emit('removeFilter', this.filter.code);
        },
        updateVisibility(visibility) {
            this.$emit('update:displayDropdown', visibility);
        },
    },
};
</script>
